import { render, staticRenderFns } from "./getBalance.vue?vue&type=template&id=6a9f7af9"
import script from "./getBalance.vue?vue&type=script&lang=js"
export * from "./getBalance.vue?vue&type=script&lang=js"
import style0 from "./getBalance.vue?vue&type=style&index=0&id=6a9f7af9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports